module.exports = __webpack_public_path__ + "static/young-woman-a86858d66eb41ee919dace4788e4548d.jpg";